import { render, staticRenderFns } from "./Postgrados.vue?vue&type=template&id=82b91336&scoped=true"
import script from "./Postgrados.vue?vue&type=script&lang=js"
export * from "./Postgrados.vue?vue&type=script&lang=js"
import style0 from "./Postgrados.vue?vue&type=style&index=0&id=82b91336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b91336",
  null
  
)

export default component.exports